import get from 'lodash/get';
import RestClient from '../RestClient/RestClient';
import { RestConfig, getHostConfig } from '../Common/RestConfig';
import MyListConstants from './MyListConstants';
/**
 * This class is responsible of providing all the rewards API.
 */
const URLBase = MyListConstants.CAM_BASE;

export const getList = (params) => {
    let config = RestConfig.v5AccountConfig();
    let { accountId } = params;
    if (params.payload.accountId && params.payload.isTrendingList) {
        accountId = params.payload.accountId;
        config.isGuestUser = true;
    }
    config.url = `${URLBase}/${accountId}/${MyListConstants.GET_LIST}`;
    config.params = params.payload.params;
    config.listing = true;
    config = getHostConfig(config);
    config.accessToken = params.accessToken;
    config.XForwardedChannelHeaderHost = true;
    if (params.payload.token) {
        config.isAuthRequired = false;
    }
    if ('listId' in params.payload) {
        config.url += `/${params.payload.listId}`;
        if (params.payload.params && !params.payload.params.limit) {
            config.params.limit = 16;
        }
    }
    if (params.payload.data && params.payload.data.length > 0) {
        config.guestSavedItems = true;
        config.savedItems = params.payload.data;
    }
    if (params.payload.token && params.payload.accountId) {
        const apiUrl = `${URLBase}/${params.payload.accountId}/${MyListConstants.GUEST_VIEW}`;
        config.url = `${apiUrl}/${params.payload.listId}/${params.payload.token}`;
        delete config.accessToken;
    }
    return RestClient.get(config).then((json) => json);
};

export const getTrendingLists = () => {
    let config = RestConfig.v5AccountConfig();
    config.url = `${URLBase}/${MyListConstants.GET_TRENDING_LIST}`;
    config.listing = true;
    config = getHostConfig(config);
    return RestClient.get(config).then((json) => json);
};

export const createList = (params) => {
    let config = RestConfig.v5AccountConfig();
    config.url = `${URLBase}/${params.accountId}/${MyListConstants.GET_LIST}`;
    config.params = params.payload;
    config = getHostConfig(config);
    config.listing = true;
    config.accessToken = params.accessToken;
    return RestClient.post(config).then((response) => response);
};

/**
 * This function is used to post copied list to logged-in account.
 * API URL : /account/<account-id>/saved-items/copyList/<sourceListId>
 * @param {string} params.payload.sourceListId - Trending list ID / Shared List ID to copy
 * @param {object} params.payload.data - payload body having new list name for copied list. Ex: {"name":"destinationListName"}
 */
export const copyList = (params) => {
    let config = {};
    config = RestConfig.v5AccountConfig();

    const urlPart1 = `${URLBase}/${params.accountId}/${MyListConstants.COPY_LIST}/`;
    const urlPart2 = `${params.payload.sourceAccountId}/${params.payload.sourceListId}`;
    config.url = urlPart1 + urlPart2;

    config.listing = true;
    config.accessToken = params.accessToken;

    config.params = get(params, 'payload.data'); // data ==> {"name":"destinationListName"}

    config = getHostConfig(config);
    return RestClient.post(config).then((json) => json);
};

export const deleteList = (params) => {
    let config = RestConfig.v5AccountConfig();
    config.url = `${URLBase}/${params.accountId}/${MyListConstants.GET_LIST}/${params.payload.listId}`;
    config = getHostConfig(config);
    config.accessToken = params.accessToken;
    /* istanbul ignore else */
    if ('itemId' in params.payload) {
        config.url += '/items';
        config.params = params.payload.itemId;
    }
    return RestClient.delete(config).then((response) => response);
};

export const saveToList = (params) => {
    let config = RestConfig.v5AccountConfig();
    config.url = `${URLBase}/${params.accountId}/${MyListConstants.GET_LIST}/${params.payload.listId}`;
    config.params = params.payload.params;
    config = getHostConfig(config);
    config.accessToken = params.accessToken;
    /* istanbul ignore else */
    if ('savedItemId' in params.payload) {
        config.url += `/${params.payload.savedItemId}`;
    }

    return RestClient.patch(config).then((response) => response); // No need to handle catch, it is already handled in FetchHelper.js
};

export const shareList = (params) => {
    let config = RestConfig.v5AccountConfig();
    config = getHostConfig(config);
    config.url = `${URLBase}/${params.accountId}/${MyListConstants.GET_LIST}/${params.payload.listId}/shares`;
    config.params = params.payload.params;
    config.XForwardedChannelHeader = true;
    config.hostName = params.payload.host;
    config.listing = true;
    config.accessToken = params.accessToken;
    if (get(params.payload, 'token') && get(params.payload, 'accountId')) {
        config.XShareAccountId = params.payload.accountId;
        config.XShareToken = params.payload.token;
    }
    return RestClient.post(config).then((response) => response);
};

export const addSavedItems = (params) => {
    let config = RestConfig.v5AccountConfig();
    const url = `${MyListConstants.CAM_BASE}/${params.accountId}/${MyListConstants.GET_LIST}/`;
    config.url = `${url}${params.payload.listId}`;
    config = getHostConfig(config);
    config.listing = true;
    config.isDPClusterRequired = true;
    config.params = params.payload.pdpPayload;
    config.accessToken = params.accessToken;

    return RestClient.post(config).then((res) => res);
};

export const updateList = (params) => {
    let config = RestConfig.v5AccountConfig();
    config.url = `${URLBase}/${params.accountId}/${MyListConstants.GET_LIST}/${params.payload.listId}
/items/${params.payload.itemUUId}`;
    config.params = params.payload;
    config = getHostConfig(config);
    config.listing = true;
    config.accessToken = params.accessToken;
    return RestClient.put(config).then((response) => response); // No need to handle catch, it is already handled in FetchHelper.js // No need to handle catch, it is already handled in FetchHelper.js
};

export const deleteAllItemsList = (params) => {
    let config = RestConfig.v5AccountConfig();
    config.url = `${URLBase}/${params.accountId}/${MyListConstants.GET_LIST}/${params.payload.listId}/items`;
    config = getHostConfig(config);
    config.isDeleteAll = true;
    config.accessToken = params.accessToken;
    return RestClient.delete(config).then((response) => response);
};
